import { NavLink } from 'react-router-dom';
import {
  FiGrid,
  FiPackage,
  FiLock,
  FiSettings,
  FiLifeBuoy,
  FiMessageSquare,
  FiInbox,
} from 'react-icons/fi';
import { useAuth } from '../../context/AuthContext';
import { useSubscription } from '../../context/SubscriptionContext';

// All purchasable datasets (key matches SubscriptionContext + PAYSTACK_PLANS)
const PURCHASABLE_DATASETS = [
  { key: 'freshGoods',     label: 'Fresh Goods',     icon: '🥦', path: '/app/fresh-goods'     },
  { key: 'marketResearch', label: 'Market Research', icon: '📊', path: '/app/market-research' },
  { key: 'automotive',    label: 'Automotive',      icon: '🚗', path: '/app/automotive'      },
  { key: 'realEstate',    label: 'Real Estate',     icon: '🏢', path: '/app/real-estate'     },
  { key: 'energy',        label: 'Energy',          icon: '⚡', path: '/app/energy'          },
  { key: 'technology',    label: 'Technology',      icon: '💻', path: '/app/technology'      },
];

const SideNavBar = () => {
  const { isAdmin, isSuperAdmin } = useAuth();
  const { subscriptions } = useSubscription();

  return (
    <aside className="sidebar">
      <div className="sidebar-brand">
        <img src="/logoMain.png" alt="Trelledex" className="brand-logo-img" />
        <div>
          <p className="brand-title">Trelledex</p>
          <p className="brand-subtitle">Data Analytics</p>
        </div>
      </div>

      <nav className="sidebar-nav">
        {/* ── Main ── */}
        <div className="sidebar-section">
          <NavLink
            to="/app/dashboard"
            className={({ isActive }) => isActive ? 'sidebar-link active' : 'sidebar-link'}
          >
            <span className="sidebar-icon"><FiGrid /></span>
            Dashboard
          </NavLink>
        </div>

        {/* ── Data Sets ── */}
        <div className="sidebar-section">
          <p className="sidebar-section-title">Data Sets</p>

          {PURCHASABLE_DATASETS.map((ds) => {
            const hasAccess = subscriptions?.[ds.key] === true;
            return (
              <NavLink
                key={ds.key}
                to={ds.path}
                className={({ isActive: routeActive }) =>
                  routeActive ? 'sidebar-link active' : 'sidebar-link'
                }
              >
                <span className="sidebar-icon">{ds.icon}</span>
                <span style={{ flex: 1 }}>{ds.label}</span>
                {!hasAccess && <FiLock size={12} className="sidebar-lock-icon" />}
              </NavLink>
            );
          })}
        </div>

        {/* ── Management ── */}
        <div className="sidebar-section">
          <p className="sidebar-section-title">Management</p>
          <NavLink
            to="/app/settings"
            className={({ isActive }) => isActive ? 'sidebar-link active' : 'sidebar-link'}
          >
            <span className="sidebar-icon"><FiSettings /></span>
            Settings
          </NavLink>
          <NavLink
            to="/app/sandbox"
            className={({ isActive }) => isActive ? 'sidebar-link active' : 'sidebar-link'}
          >
            <span className="sidebar-icon"><FiPackage /></span>
            Sandbox
          </NavLink>
          <NavLink
            to="/app/support"
            className={({ isActive }) => isActive ? 'sidebar-link active' : 'sidebar-link'}
          >
            <span className="sidebar-icon"><FiMessageSquare /></span>
            Support
          </NavLink>
          {(isAdmin || isSuperAdmin) && (
            <NavLink
              to="/app/admin-tickets"
              className={({ isActive }) => isActive ? 'sidebar-link active' : 'sidebar-link'}
            >
              <span className="sidebar-icon"><FiInbox /></span>
              Ticket Admin
            </NavLink>
          )}
        </div>
      </nav>

      <div className="sidebar-card">
        <div>
          <p className="sidebar-card-title">Data Capacity</p>
          <p className="sidebar-card-text">1% of monthly quota used</p>
        </div>
        <div className="sidebar-progress" style={{ '--progress': '1%' }}>
          <span />
        </div>
      </div>

      <div className="sidebar-footer">
        <NavLink to="/app/support" style={{ textDecoration: 'none', color: 'inherit', display: 'flex', alignItems: 'center', gap: 4 }}>
          <FiLifeBuoy size={12} /> Support
        </NavLink>
        <span>2026.03.30.V1</span>
      </div>
    </aside>
  );
};

export default SideNavBar;
